export enum DownPaymentMethod {
  Card = 'card',
  Wire = 'wire',
}
